import { useState, type ReactNode } from 'react';
import { Link } from 'react-router';
import { Alert } from 'components/common';
import { analytics, useUser } from 'libs';

interface PlatinumUpgradeBannerProps {
  children?: ReactNode;
  isDismissable?: boolean;
}

const PlatinumUpgradeBanner = ({ children = null, isDismissable = true }: PlatinumUpgradeBannerProps) => {
  const user = useUser();
  const [isOpen, setIsOpen] = useState(true);

  if (user.features.has_brokerage || user.features.is_pro || user.features.has_past_due_payments || !isOpen) {
    return null;
  }

  return (
    <Alert
      isDismissable={isDismissable}
      onClose={() => {
        setIsOpen(false);
        analytics.upgrade.bannerHide('Platinum');
      }}
      testId="platinum-upgrade-banner"
      variant="primary-light"
    >
      {children || user.features.eligible_for_free_trial ? (
        <div className="fw-bold text-black">
          Try Platinum for 30 days and get full access to rates, lenders, policies, plus the AI Assistant and Scenarios.{' '}
          <Link
            data-testid="platinum-upgrade-banner-link"
            onClick={analytics.upgrade.bannerLinkClick('Free Trial', 'Subscriptions')}
            to="/settings/upgrade"
          >
            Start your free trial today
          </Link>
          .
        </div>
      ) : (
        <div className="fw-bold text-black">
          Your current plan is Basic. Get full access to rates, lenders, policies, and the option to purchase the AI
          Assistant when you{' '}
          <Link
            data-testid="platinum-upgrade-banner-link"
            onClick={analytics.upgrade.bannerLinkClick('Platinum', 'Subscriptions')}
            to="/settings/upgrade"
          >
            upgrade to Platinum
          </Link>
          .
        </div>
      )}
    </Alert>
  );
};

export default PlatinumUpgradeBanner;
